require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-146-project-start-and-end-dates.json") })
        }
      }, "path---article-146-project-start-and-end-dates");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-146-project-start-and-end-dates!./.cache/json/article-146-project-start-and-end-dates.json
// module id = 496
// module chunks = 231608221292675